import { HOST } from "../../utils/constants";
import { IRequest } from "../Couch/request";
import { HEADERS } from "./headers";

export interface IRequestEmailBody {
  event: string;
  request: string;
}

export interface IInviteManager {
  club: string;
  email: string;
  name: string;
  role: string;
  status?: "AUTO"
}

export interface IApprovalEmailBody {
  parti: string;
  event: string;
  note: string;
}

export const postRequestEmail = async (data: IRequestEmailBody) => {
  const response = await fetch(HOST+ "email/request", {
    ...HEADERS,
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });
  return response.json();
};

export const inviteManagerEmail = async (data: IInviteManager) => {
  const response = await fetch(HOST+ "email/inviteManager", {
    ...HEADERS,
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });
  return response.json();
};

export const createEntryReqyest = async (data: IRequest) => {
  const response = await fetch(HOST+ "request", {
    ...HEADERS,
    method: "POST",
    body: JSON.stringify(data),
  });
  return response.json();
}

export const getEventRequests = async (event: string) => {
  const response = await fetch(HOST+ "request/"+ event, {
    ...HEADERS,
    method: "GET",
  });
  return response.json();
};

export const checkAlreadyEntered = async (athleteId: string, eventId: string) => {
  const response = await fetch(HOST+ "request/check/"+ athleteId + "/" + eventId, {
    ...HEADERS,
    method: "GET",
  });
  return response.json();
}

// export const postApprovalEmail = async (data: IApprovalEmailBody) => {
//   const response = await fetch(HOST+ "email/approval", {
//     ...HEADERS,
//     body: JSON.stringify(data), // body data type must match "Content-Type" header
//   });
//   return response.json();
// };